const Hero = () => {
  return (
    <section
      className="h-screen w-full bg-cover bg-center flex items-center justify-start relative"
      style={{ backgroundImage: "url('/images/gymmm.jpg')" }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-primary/40"></div>

      {/* Left aligned heading + tagline */}
      <div className="absolute top-20 left-12 z-10 max-w-2xl">
        <h1 className="text-white font-bebas font-extrabold text-6xl md:text-8xl leading-tight">
          POWER AND PUMP <br /> FITNESS FORGE
        </h1>
        <p className="mt-6 text-white text-lg md:text-2xl font-semibold tracking-wide uppercase">
          Unleash Your Strength. Build The Body. Forge The Mind.
        </p>
      </div>
    </section>
  );
};

export default Hero;
